<!-- Recurrence Pattern -->
<main class="d-flex flex-column mb-4">
  <label class="mb-3 recurrence-pattern-header">{{ 'donate.recurring.contribution.labels.pattern' | translateLang }}<span class="required-asterisk">*</span></label>
  <div id="recurrences" class="d-flex">
    <div *ngFor="let recurrence of recurrences" class="recurrence-pattern-radio">
      <p-radiobutton
        [formControl]="recurrencePattern"
        [value]="recurrence"
        [inputId]="'pattern-' + recurrence"
      />
      <label [for]="'pattern-' + recurrence">
        {{ 'donate.recurring.contribution.labels.pattern.' + recurrence.toLowerCase().replaceAll('_', '.') | translateLang }}
      </label>
    </div>
  </div>
</main>

<form [formGroup]="recurrenceRange" class="container-grid pb-3">
  <!-- Label -->
  <label class="mb-2 range-header">{{ 'donate.recurring.contribution.labels.range' | translateLang }}<span class="required-asterisk">*</span></label>

  <!-- Start Date -->
  <section class="d-flex flex-column" style="gap: 5px;">
    <label>{{ 'donate.recurring.contribution.labels.range.start' | translateLang }}</label>
    <p-datepicker
      formControlName="startDate"
      [dateFormat]="dateFormatSignal()"
      [minDate]="minStartDate()"
      [maxDate]="maxStartDate()"
      [readonlyInput]="true"
      styleClass="recurring-date-input"
    />
  </section>

  <!-- End Date Options -->
  <section class="d-flex flex-column" style="gap: 5px;">
    <label>{{ 'donate.recurring.contribution.labels.range.end.by' | translateLang }}</label>

    <div class="d-flex flex-column" style="gap: 13px;">
      <!-- End By Option -->
      <div class="d-flex align-items-center" style="gap: 13px;">
        <div class="range-option-radio">
          <p-radiobutton
            formControlName="rangeOption"
            inputId="end-by"
            [value]="endOptions.ENDBY"
          />
          <label for="end-by">{{ 'donate.recurring.contribution.labels.range.end.by' | translateLang }}</label>
        </div>
        <p-datepicker
          formControlName="endDate"
          [dateFormat]="dateFormatSignal()"
          [minDate]="minEndDate()"
          [readonlyInput]="true"
          (onFocus)="!control.disabled && recurrenceRange.get('rangeOption')?.patchValue(endOptions.ENDBY)"
          styleClass="recurring-date-input"
        />
      </div>

      <!-- End After X Occurrences Option -->
      <div class="d-flex align-items-center" style="gap: 13px;">
        <div class="range-option-radio">
          <p-radiobutton
            formControlName="rangeOption"
            inputId="end-after"
            [value]="endOptions.ENDAFTER"
          />
          <label for="end-after">
            {{ (isSinngeber ? '' : 'donate.recurring.contribution.labels.range.end.after') | translateLang }}
          </label>
        </div>
        <div class="d-flex align-items-center" style="gap: 13px;">
          <p-inputnumber
            formControlName="rangeOccurrences"
            [showButtons]="true"
            [step]="1"
            [min]="2"
            styleClass="occurrence-input"
            (onFocus)="!control.disabled && recurrenceRange.get('rangeOption')?.patchValue(endOptions.ENDAFTER)"
          />
          <span>{{ 'donate.recurring.contribution.labels.range.occurrences' | translateLang }}</span>
        </div>
      </div>

      <!-- No End Date Option -->
      <div *ngIf="!hideNoEndDate" class="range-option-radio">
        <p-radiobutton
          formControlName="rangeOption"
          inputId="no-end"
          [value]="endOptions.NOEND"
        />
        <label for="no-end">{{ 'donate.recurring.contribution.labels.range.no.end' | translateLang }}</label>
      </div>

      <!-- Validation Errors -->
      <p *ngIf="rangeEndErrors?.required" class="small text-danger m-0">
        {{ 'form.validators.date.required' | translateLang }}
      </p>
      <p *ngIf="rangeEndErrors?.notZero" class="small text-danger m-0">
        {{ 'form.validators.recurring.value.positive' | translateLang }}
      </p>
      <p *ngIf="rangeEndErrors?.noSelection" class="small text-danger m-0">
        {{ 'form.validators.recurring.option.required' | translateLang }}
      </p>
    </div>
  </section>
</form>
